<template>
  <div id="studentMockList">
    <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>

    <!-- 当前查询条件信息 -->
    <div class="info-bar">
      <span>考试课程：{{ courseName || "-" }}</span>
      <span style="margin-left: 24px">模考名称：{{ mockName || "-" }}</span>
      <el-tag
        style="margin-left: 24px"
        size="small"
        :type="mockStatus === '1' ? 'success' : 'warning'"
      >
        {{ mockStatus === "1" ? "已参加模考" : "未参加模考" }}
      </el-tag>
    </div>

    <ots-table-group-new
      v-loading="loading"
      :selectList="selectList"
      :requestForm="requestForm"
      :tableHeader="tableHeader"
      :tableOption="tableOption"
      :tableData="tableData"
      :pagination="pagination"
      @search="search"
      @changeNum="changeSize"
      @changePage="changePage"
    ></ots-table-group-new>

    <!-- 模考日志弹窗 -->
    <ots-custom-dialog :dialog.sync="recordDialogVisible" title="模考日志" width="700px">
      <template v-slot:content>
        <el-table :data="recordList" v-loading="recordLoading" border stripe size="small" style="width: 100%">
          <el-table-column label="序号" type="index" width="80" align="center" />
          <el-table-column label="开始时间" width="200" align="center">
            <template slot-scope="{ row }">
              <span v-if="row.startTime">{{ formatTime(row.startTime) }}</span>
              <span v-else class="text-muted">-</span>
            </template>
          </el-table-column>
          <el-table-column label="提交时间" width="200" align="center">
            <template slot-scope="{ row }">
              <span v-if="row.submitTime">{{ formatTime(row.submitTime) }}</span>
              <span v-else class="text-muted">-</span>
            </template>
          </el-table-column>
          <el-table-column label="分数" prop="score" align="center" min-width="90" show-overflow-tooltip />
        </el-table>
        <div v-if="!recordLoading && recordList.length === 0" class="empty-tip">暂无模考记录</div>
      </template>
    </ots-custom-dialog>
  </div>
</template>


<script>
import {
  studentMockGetStudentMockListApi,
  studentMockGetMockRecordLogApi,
  studentMockGetStudentMockExportApi
} from "@/http/modules/applySet/studentMock.js";


export default {
  name: "StudentMockList",
  data() {
    return {
      loading: false,
      exporting: false,
      mainTopBtnList: [
        { title: "返回", type: "info", plain: true, fn: this.goBack },
        { title: "导出", fn: this.handleExport }
      ],

      // 路由参数
      planId: "",
      courseId: "",
      courseName: "",
      mockName: "",
      mockStatus: "",

      // 查询条件
      requestForm: {
        searchKey: "",
        page: 1,
        size: 10
      },
      selectList: [
        {
          title: "姓名/证件号",
          type: "input",
          requestKey: "searchKey",
          placeholder: "请输入"
        }
      ],
      tableOption: {},
      tableData: [],
      pagination: { total: 0, page: 1, size: 10 },

      // 日志弹窗
      recordDialogVisible: false,
      recordLoading: false,
      recordList: []
    };
  },
  computed: {
    tableHeader() {
      const baseColumns = [
        { title: "考试批次", prop: "planName", width: 200 },
        { title: "考试课程", prop: "courseName", width: 200 },
        { title: "模考名称", prop: "mockName", align: "center" },
        { title: "姓名", prop: "realName", width: 130 },
        { title: "证件号", prop: "cardNo", width: 130 },
        { title: "手机号", prop: "phone", width: 130 },
        { title: "电子邮箱", prop: "email", width: 130 }
      ];
      // 未参加模考：隐藏「作答次数、最后模考时间、操作」
      if (this.mockStatus !== "1") {
        return baseColumns;
      }
      return [
        ...baseColumns,
        { title: "作答次数", prop: "mockAnswerTime", width: 100, align: "center" },
        {
          title: "最后模考时间",
          width: 180,
          formatter: scope =>
            scope.row.mockLastDate ? this.formatTime(scope.row.mockLastDate) : "-"
        },
        {
          title: "操作",
          type: "buttons",
          width: 120,
          btnList: [{ title: "查看日志", click: this.openRecordLog }]
        }
      ];
    }
  },
  created() {
    const query = this.$route.query || {};
    this.planId = query.planId || "";
    this.courseId = query.courseId || "";
    this.courseName = query.courseName || "";
    this.mockName = query.mockName || "";
    this.mockStatus = query.mockStatus || "";

    if (!this.planId || !this.courseId) {
      this.$message.error("参数缺失，请从模考查询页进入");
      return;
    }
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      try {
        const params = {
          planId: this.planId,
          courseIds: this.courseId,
          searchKey: this.requestForm.searchKey,
          mockStatus: this.mockStatus,
          page: this.requestForm.page,
          size: this.requestForm.size
        };
        const { data } = await studentMockGetStudentMockListApi(params);
        this.tableData = (data && data.records) || [];
        this.pagination.total = (data && data.total) || 0;
        this.pagination.page = this.requestForm.page;
        this.pagination.size = this.requestForm.size;
      } finally {
        this.loading = false;
      }
    },
    search() {
      this.requestForm.page = 1;
      this.loadData();
    },
    changeSize(size) {
      this.requestForm.size = size;
      this.requestForm.page = 1;
      this.pagination.size = size;
      this.loadData();
    },
    changePage(page) {
      this.requestForm.page = page;
      this.pagination.page = page;
      this.loadData();
    },
    async openRecordLog(row) {
      this.recordDialogVisible = true;
      this.recordLoading = true;
      this.recordList = [];
      try {
        const { data } = await studentMockGetMockRecordLogApi({
          studentCourseId: row.studentCourseId
        });
        this.recordList = data || [];
      } finally {
        this.recordLoading = false;
      }
    },
    async handleExport() {
      if (this.exporting) return;
      this.exporting = true;
      const params = {
        planId: this.planId,
        courseIds: this.courseId,
        searchKey: this.requestForm.searchKey,
        mockStatus: this.mockStatus
      };
      try {
        const { code, data, msg, error } = await studentMockGetStudentMockExportApi(params);
        if (code === 1 && data) {
          // 后端返回文件 URL，触发浏览器下载
          const link = document.createElement("a");
          link.href = data;
          link.download = "";
          link.target = "_blank";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.$message.success("导出成功");
        } else {
          this.$message.error(msg || error || "导出失败");
        }
      } catch (e) {
        console.error("export error:", e);
        this.$message.error("导出失败");
      } finally {
        this.exporting = false;
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    formatStatusColumn(row, col, val) {
      if (val === null || val === undefined || val === "") return "-";
      return STATUS_MAP[val] || val;
    },
    formatTime(t) {
      if (!t) return "";
      if (Array.isArray(t)) {
        const [y, M, d, h = 0, m = 0, s = 0] = t;
        return `${y}-${String(M).padStart(2, "0")}-${String(d).padStart(2, "0")} ${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
      }
      return String(t).replace("T", " ");
    }
  }
};
</script>


<style scoped lang="less">
#studentMockList {
  padding: 0 20px;
}
.info-bar {
  margin-bottom: 12px;
  padding: 12px 16px;
  background: #f5f7fa;
  border-radius: 4px;
  font-size: 14px;
  color: #303133;
}
.text-muted {
  color: #c0c4cc;
}
.empty-tip {
  padding: 16px;
  text-align: center;
  color: #909399;
}
</style>
